import title from 'text!./templates/Title.html';

export default [() => ({
    restrict: 'E',
    replace: true,
    transclude: true,
    template: title,
    scope: {},
    link: ($scope, $element, $attrs) => {
        if ('offset' in $attrs) {
            $scope.hasOffset = true;
        }
    }
})];